import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { StoreType } from "../../../../core/store/reducers";
import { FetchStateType } from "../../../models";
import { deleteInvoice } from "../thunks/deleteInvoice";
import { setFetchState } from "../invoicesDataSlice";

export const useInvoiceDelete = () => {
  const fetchState = useSelector<StoreType, FetchStateType>(
    (store) => store.data.accounting.invoices.cancelFetchState
  );

  const dispatch = useDispatch();
  const dispatchDeleteInvoice = React.useCallback(
    (id: string) => dispatch(deleteInvoice(id)),
    [dispatch]
  );

  React.useEffect(() => {
    dispatch(setFetchState({ type: "not-started" }));
  }, [dispatch]);

  return [fetchState, dispatchDeleteInvoice] as [
    typeof fetchState,
    typeof dispatchDeleteInvoice
  ];
};
